(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('product-variant-media-controller')) {
  customElements.define('product-variant-media-controller', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.section = this.closest('product-form') || this.closest('.js-product');
      this.carousel = this.gallery?.querySelector('.main-image carousel-slider');
      this.slider = this.carousel?.querySelector('.slider');
      this.nav = this.carousel?.querySelector('.slider-nav');
      if (!this.gallery || !this.section) return;

      const dataElement = this.gallery.querySelector('.js-product-media-filter');
      this.data = dataElement ? JSON.parse(dataElement.textContent) : null;
      this.selection = { group: this.data?.initialGroup, mediaId: this.data?.initialMediaId };
      this.guardDynamicHeight();

      this.onVariant = event => {
        this.applySelection(this.readSelection(event.detail));
        this.queueFilter();
      };
      this.onOption = event => {
        if (event.target.closest('variant-picker, .option-selector:not(.option-selector--custom)') || event.target.name === 'id') {
          this.queueFilter();
        }
      };
      this.section.addEventListener('on:variant:change', this.onVariant, true);
      this.section.addEventListener('change', this.onOption);
      this.section.addEventListener('input', this.onOption);
      this.section.addEventListener('click', this.onOption);

      this.onClick = this.handleClick.bind(this);
      this.onScroll = () => this.queueUpdate(false);
      this.onResize = () => this.queueUpdate(true);
      this.nav?.addEventListener('click', this.onClick, true);
      this.slider?.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('on:debounced-resize', this.onResize);

      this.observer = new MutationObserver(() => this.queueFilter());
      this.observer.observe(this.gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
      this.optionObserver = new MutationObserver(() => this.queueFilter());
      this.optionObserver.observe(this.section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'value', 'aria-selected']
      });

      this.applySelection(this.readSelection());

      customElements.whenDefined('carousel-slider').then(() => {
        if (this.isConnected) {
          this.guardDynamicHeight();
          this.applySelection(this.readSelection());
          this.queueUpdate(true);
        }
      });
    }

    disconnectedCallback() {
      this.nav?.removeEventListener('click', this.onClick, true);
      this.slider?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('on:debounced-resize', this.onResize);
      this.observer?.disconnect();
      this.optionObserver?.disconnect();
      this.section?.removeEventListener('on:variant:change', this.onVariant, true);
      this.section?.removeEventListener('change', this.onOption);
      this.section?.removeEventListener('input', this.onOption);
      this.section?.removeEventListener('click', this.onOption);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.filterFrame);
      if (this.carousel?.updateDynamicHeight === this.heightUpdateGuard) {
        this.carousel.updateDynamicHeight = this.heightUpdateOriginal;
      }
    }

    guardDynamicHeight() {
      const original = this.carousel?.updateDynamicHeight;
      if (this.heightUpdateGuard || typeof original !== 'function') return;
      this.heightUpdateOriginal = original;
      this.heightUpdateGuard = function (...args) {
        if (!this.slides?.length || !this.slider) return;
        const span = Math.abs(this.slideSpan) || this.slider.clientWidth || 1;
        const index = Math.round(Math.abs(this.slider.scrollLeft) / span);
        this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, index));
        return original.apply(this, args);
      };
      this.carousel.updateDynamicHeight = this.heightUpdateGuard;
    }

    normalize(value) {
      return String(value ?? '').trim().toLocaleLowerCase();
    }

    resolveGroup(value) {
      if (value == null || value === '') return null;
      const match = this.data?.values.find(option =>
        String(option.id) === String(value) || this.normalize(option.name) === this.normalize(value));
      return match?.name || String(value);
    }

    getGroupSelector() {
      if (this.data?.groupOptionIndex == null) return null;
      const picker = this.section.querySelector('variant-picker') || this.section;
      const selectors = Array.from(picker.querySelectorAll('.option-selector:not(.option-selector--custom)'));
      return selectors.find(selector =>
        this.normalize(selector.dataset.option || selector.dataset.optionName) === this.normalize(this.data.groupOptionName)) ||
        selectors.find(selector => Number(selector.dataset.index) === this.data.groupOptionIndex + 1) ||
        selectors[this.data.groupOptionIndex];
    }

    readSelection(detail = {}) {
      if (!this.data?.enabled) return this.selection;
      const selector = this.getGroupSelector();
      const selectedInput = selector?.querySelector('input:checked, select');
      const selectedItem = selector?.querySelector('[aria-selected="true"][data-value]');
      let group = this.resolveGroup(selectedInput?.value || selectedItem?.dataset.value);
      if (!group && this.data.groupOptionIndex != null) {
        group = this.resolveGroup(detail.selectedOptions?.[this.data.groupOptionIndex] ||
          detail.variant?.options?.[this.data.groupOptionIndex]);
      }
      const variantInput = this.section.querySelector('form[action*="/cart/add"] [name="id"], .js-product-form [name="id"]');
      const record = this.data.variants.find(variant => String(variant.id) === String(detail.variant?.id || variantInput?.value));
      if (!group) group = record?.group;
      if (!group) group = this.selection?.group;
      if (!group && this.data.groupOptionIndex != null) {
        const picker = this.section.querySelector('variant-picker');
        if (typeof picker?.getSelectedOptions === 'function') {
          group = this.resolveGroup(picker.getSelectedOptions()[this.data.groupOptionIndex]);
        }
      }
      group ||= this.selection?.group || this.data.initialGroup;

      const sameGroup = this.normalize(group) === this.normalize(this.selection?.group);
      const groupRecord = this.data.variants.find(variant =>
        variant.mediaId && this.normalize(variant.group) === this.normalize(group));
      const valueRecord = this.data.values.find(option =>
        option.mediaId && this.normalize(option.name) === this.normalize(group));
      let mediaId = detail.variant?.featured_media?.id;
      if (!mediaId && record && (!group || this.normalize(record.group) === this.normalize(group))) mediaId = record.mediaId;
      mediaId ||= groupRecord?.mediaId || valueRecord?.mediaId || (sameGroup ? this.selection?.mediaId : null);
      if (!group && !mediaId) mediaId = this.data.initialMediaId;
      return { group: group || null, mediaId: mediaId || null };
    }

    queueFilter() {
      if (this.filterFrame) return;
      this.filterFrame = requestAnimationFrame(() => {
        this.filterFrame = null;
        if (this.isConnected) this.applySelection(this.readSelection());
      });
    }

    getMediaLists() {
      const lists = [];
      const roots = [this.gallery, this.gallery.galleryModal];
      const template = this.gallery.querySelector('.js-media-zoom-template');
      if (template?.content) roots.push(template.content);
      roots.filter(Boolean).forEach(root => {
        const parents = new Map();
        root.querySelectorAll('.slider__item[data-media-id], .product-media-collage__item[data-media-id], .gallery-viewer__thumb[data-media-id]')
          .forEach(item => {
            if (!parents.has(item.parentElement)) parents.set(item.parentElement, []);
            parents.get(item.parentElement).push(item);
          });
        parents.forEach(items => lists.push(items));
      });
      return lists;
    }

    applySelection(selection) {
      if (!this.data?.enabled || !selection) {
        this.queueUpdate(true);
        return;
      }
      const group = this.normalize(selection.group);
      const selectedMediaId = selection.mediaId == null ? null : String(selection.mediaId);
      const grouped = group && Object.values(this.data.media).some(media =>
        media.group !== true && media.group != null && this.normalize(media.group) === group);
      const unselected = !group && !selectedMediaId;
      const visible = id => {
        const media = this.data.media[id];
        return unselected || media?.group === true || (grouped ?
          media?.group != null && this.normalize(media.group) === group : String(id) === selectedMediaId);
      };
      const changedGroup = this.lastGroup !== group;
      let changedMedia = false;

      const lists = this.getMediaLists();
      lists.forEach(items => {
        items.forEach(item => {
          const hide = !visible(item.dataset.mediaId);
          if (item.hidden !== hide) {
            item.hidden = hide;
            changedMedia = true;
          }
          if (hide) item.setAttribute('data-vm-hidden', 'true');
          else item.removeAttribute('data-vm-hidden');
        });
        const rank = item => {
          const media = this.data.media[item.dataset.mediaId];
          if (item.hidden) return 10000 + (media?.index || 0);
          if (media?.group === true) return media.position === 'start' ? -10000 + (media.index || 0) : 5000 + (media.index || 0);
          return media?.index || 0;
        };
        const ordered = items.slice().sort((a, b) => rank(a) - rank(b));
        if (ordered.some((item, index) => items[index] !== item)) {
          ordered.forEach(item => item.parentElement.appendChild(item));
          changedMedia = true;
        }
      });

      this.selection = selection;
      this.lastGroup = group;
      this.gallery.dataset.variantMediaState = unselected ? 'unselected' : grouped || selectedMediaId ? 'filtered' : 'missing-association';
      const currentActive = this.gallery.querySelector('.main-image .slider__item.is-active');
      const invalidActive = currentActive?.hidden;
      if (!changedMedia && !changedGroup && !invalidActive) return;

      this.gallery.querySelectorAll('carousel-slider').forEach(carousel => {
        if (carousel.offsetParent && typeof carousel.refresh === 'function') carousel.refresh();
      });

      const slides = Array.from(this.gallery.querySelectorAll('.main-image .slider__item')).filter(item => !item.hidden);
      const active = slides.find(item => item.dataset.mediaId === selectedMediaId) ||
        (!changedGroup && slides.find(item => item.classList.contains('is-active'))) ||
        slides.find(item => this.data.media[item.dataset.mediaId]?.group !== true) || slides[0];
      if (active) {
        if (typeof this.gallery.setActiveMedia === 'function') {
          this.gallery.setActiveMedia(active.dataset.mediaId, false, true);
        } else {
          lists.forEach(items => items.forEach(item => item.classList.toggle('is-active',
            !item.hidden && item.dataset.mediaId === active.dataset.mediaId)));
          const slide = this.slider?.getBoundingClientRect();
          const bounds = active.getBoundingClientRect();
          if (slide && this.slider.clientWidth) this.slider.scrollTo({
            left: this.slider.scrollLeft + (bounds.left + bounds.right - slide.left - slide.right) / 2,
            behavior: 'instant'
          });
        }
      }
      this.queueUpdate(true);
    }

    getSlides() {
      if (!this.carousel) return [];
      return Array.from(this.carousel.querySelectorAll('.slider__grid > .slider__item'))
        .filter(slide => !slide.hidden && slide.getClientRects().length > 0);
    }

    getCurrentIndex(slides) {
      if (!slides.length) return -1;
      const viewport = this.slider.getBoundingClientRect();
      const center = (viewport.left + viewport.right) / 2;
      let nearestIndex = 0;
      let nearestDistance = Infinity;
      slides.forEach((slide, index) => {
        const bounds = slide.getBoundingClientRect();
        const distance = Math.abs((bounds.left + bounds.right) / 2 - center);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      return nearestIndex;
    }

    queueUpdate(refresh) {
      if (!this.slider || !this.nav) return;
      this.needsRefresh = this.needsRefresh || refresh;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.isConnected || this.slider.clientWidth === 0) return;
        const slides = this.getSlides();
        if (this.needsRefresh && typeof this.carousel.refresh === 'function') {
          this.carousel.refresh();
        }
        this.needsRefresh = false;
        this.updateButtons(slides);
      });
    }

    updateButtons(slides) {
      const index = this.getCurrentIndex(slides);
      const previous = this.nav.querySelector('button[name="prev"]');
      const next = this.nav.querySelector('button[name="next"]');
      if (previous) previous.disabled = slides.length < 2 || index <= 0;
      if (next) next.disabled = slides.length < 2 || index >= slides.length - 1;
    }

    handleClick(event) {
      const button = event.target.closest('button[name="prev"], button[name="next"]');
      if (!button || !this.nav.contains(button) || button.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const slides = this.getSlides();
      if (slides.length < 2) {
        this.updateButtons(slides);
        return;
      }

      const cachedSlides = this.carousel.slides;
      const staleSlides = !cachedSlides || cachedSlides.length !== slides.length ||
        slides.some((slide, index) => cachedSlides[index] !== slide);
      if (staleSlides && typeof this.carousel.refresh === 'function') {
        this.carousel.refresh();
      }

      const index = this.getCurrentIndex(slides);
      const targetIndex = Math.max(0, Math.min(slides.length - 1,
        index + (button.name === 'next' ? 1 : -1)));
      const target = slides[targetIndex];
      const bounds = target.getBoundingClientRect();
      const viewport = this.slider.getBoundingClientRect();
      const offset = (bounds.left + bounds.right - viewport.left - viewport.right) / 2;

      this.slider.scrollTo({
        left: this.slider.scrollLeft + offset,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
